import React from 'react'
import DealPropertyChangePicker from './DealPropertyChangePicker'
import { SnackBar } from '../../common/components/SnackBar/SnackBar'

/** Minimal shell for HubSpot deal-property sync modal (no full HubspotApp bundle). */
const DealPropertyChangeIframe: React.FC = () => (
  <>
    <DealPropertyChangePicker />
    <SnackBar />
  </>
)

export default DealPropertyChangeIframe
